import PropTypes from 'prop-types';
import React from 'react';

import TeamAssistV2ImageAnalysisCard, {
  imageAnalysisHtml,
} from 'components/customer/team_assist_v2/team_assist_v2_image_analysis_card';

/**
 * The card a surfaced tool result renders as, chosen by the `resultType` glados
 * tagged it with. A call with no surfaced result, a failed one, or one whose
 * `resultType` this client doesn't know yet renders nothing, so a card type
 * newer than the client is left out rather than shown broken.
 */
export default function TeamAssistV2ToolCard({ execution }) {
  if (!execution || execution.isError) {
    return null;
  }
  const Card = cardFor(execution.resultType);
  return Card ? <Card result={execution.result} /> : null;
}

TeamAssistV2ToolCard.propTypes = {
  execution: PropTypes.shape({
    isError: PropTypes.bool,
    result: PropTypes.any,
    resultType: PropTypes.string,
  }),
};

/**
 * A surfaced tool result's card as HTML, for Copy, or '' when it has no card.
 * `options` is `{ locale, t }`.
 */
export function toolCardHtml(execution, options) {
  if (!execution || execution.isError) {
    return '';
  }
  switch (execution.resultType) {
    case 'image_analysis':
      return imageAnalysisHtml(execution.result, options);
    default:
      return '';
  }
}

function cardFor(resultType) {
  switch (resultType) {
    case 'image_analysis':
      return TeamAssistV2ImageAnalysisCard;
    default:
      return null;
  }
}
